<template lang="pug">
div.nse-poster-preview.style-poet
	star-map-preview(
		:spec="spec"
		:selected-items="selectedItems"
		:dimensions="dimensions"
		:clip-path="clipPath"
		:background-color="bgStarmap"
	)

	div.preview-element.map-gradient(:style="styleGradient")
	div.preview-element.caption-map(:style="captionStyle")

	text-element-preview(
		v-if="spec.text_detail"
		:spec="spec.text_detail"
		:selected-items="selectedItems"
		:text-color-force="colorTexture"
		:font-family="selectedItems.detail_font"
	)
		div.text-content
			div(v-html="textDateTime")
			div(v-html="textLocationCoor")

	text-element-preview(
		v-if="spec.text_saying"
		:spec="spec.text_saying"
		:selected-items="selectedItems"
		:text-color-force="colorTexture"
		:font-family="selectedItems.message_font"
	)
		div.text-content
			div(v-html="textSaying")

	border-preview(
		:selected-items="selectedItems"
		:dimensions="dimensions"
		:border-color="colorTexture"
	)

	frame-physical-preview(
		:selected-items="selectedItems"
		:dimensions="dimensions"
	)
</template>


<script>
import {computed} from "vue";
import ParseSpecifications from "@/commons/ParseSpecifications";
import TextElementPreview from "@/preview/components/TextElement";
import TextParse from "@/commons/TextParse";
import StarMapPreview from "@/preview/components/StarMapPreview";
import PathSvg from "@/commons/PathSvg";
import {PreviewHelper} from "@/preview/PreviewHelper";

export default {
	name: "PoetStyle",
	components: {StarMapPreview, TextElementPreview},
	props: {
		selectedItems: {
			type: Object,
			default() {
				return {}
			}
		},

		dimensions: {
			type: Object,
			default() {
				return {}
			}
		}
	},

	setup(props) {
		const spec = computed(() => {
			return ParseSpecifications.parse(props.selectedItems.poster_size, props.dimensions)
		});

		const colorTexture = computed(() => {
			return '#ffffff';
		});

		const {
			textSaying,
			textLocation,
			textCountry,
			textCity,
			textCoordinate,
            textDateTime,
			textTitle
		} = TextParse(props);

		const styleBG = computed(() => {
			return `background-color: ${bgStarmap.value}`
		});

		const captionStyle = computed((() => {
			return `bottom: 0; height: 10%;`;
		}));

		const styleGradient = computed(() => {

			var color = '#000000';
			if (props.selectedItems.star_map_color) {
				color = `${props.selectedItems.star_map_color.value}`
			}

			var s = `
				width: ${spec.value.background_gradient.width_modifier}%;
				height: ${spec.value.background_gradient.height_modifier}%;
				top: ${spec.value.background_gradient.y_modifier}%;
				left: ${spec.value.background_gradient.x_modifier}%;
				background-image: linear-gradient(${color}00, ${color} ${spec.value.background_gradient.y1}%)
			`;
			return s;
		})
		const bgStarmap = computed(() => {
			return props.selectedItems.background_color ? props.selectedItems.background_color.value : ''
		});


		const specShape = computed(() =>{
			var s = spec.value.star_map;
			if (spec.value.star_map_shape && spec.value.star_map_shape.top > 0) {
				s = spec.value.star_map_shape
			}
			return s;
		});

		const clipPath = computed(() =>{
			var w = props.selectedItems.poster_size.poster_width / 100 * specShape.value.width;
			var h = props.selectedItems.poster_size.poster_height / 100 * specShape.value.height;

			var hShape = 700 / (w/h);
			return PathSvg.rectangle(700, hShape)
		});

		const textLocationCoor = computed(() => {
            var t = textLocation.value;
            if (textLocation.value && textCoordinate.value) {
                t += ' - '
            }
            t += textCoordinate.value
		    return t
        })

		return {
			bgStarmap,
			spec,
			colorTexture,
			textSaying,
			textLocation,
            textDateTime,
			textCountry,
			textCity,
			textCoordinate,

			textTitle,
			styleBG,
			captionStyle,
			styleGradient,
			clipPath,
            textLocationCoor
		}
	}
}
</script>


